import * as React from 'react';
import * as styles from './SofortIcon.scss';

export default (props: any) => (
  <div className={styles.logoContainer}>
    <img
      className={styles.logo}
      src="https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-sofort-new-corrected.svg"
      style={props.style}
    />
  </div>
);



// WEBPACK FOOTER //
// ./components/icons/SofortIcon/SofortIcon.tsx